require('./gameActionsService');
require('../../fhApp/currentUser/currentUser');

angular.module('app.schedule.gameActions.gameActionsController', [
  'app.schedule.gameActions.gameActionsService',
  'app.currentUser'
])
  .controller('app.schedule.gameActions.gameActionsController', [
    '$scope',
    'app.schedule.gameActions.gameActionsService',
    'currentUser',
    function ($scope, gameActions, currentUser) {
      "use strict";

      $scope.currentUser = currentUser;
      $scope.downloadLinks = {};
      $scope.retrievingDownloads = {};

      /**
       * @param {Game} game
       * @param {boolean} secondary
       * @returns {*}
       */
      $scope.playIconClass = function (game, secondary) {
        if (typeof secondary === 'undefined') {
          secondary = false;
        }

        if (game.can_play) {
          let icon = 'fa-play-circle';

          if (game.multiple_audio === 1) {
            if (game.multiple_audio_override === 0) {
              icon = 'fa-play-circle-o';
            }
            else {
              if (secondary) {
                icon = 'fa-play-circle-o';
              }
            }
          }
          else {
            if (game.multiple_audio_override === 2) {
              if (secondary) {
                icon = 'fa-play-circle-o';
              }
            }
          }
          return icon;
        }
        return false;
      };

      $scope.playMessage = function (game, secondary) {
        if (typeof secondary === 'undefined') {
          secondary = false;
        }

        if (game.can_play) {
          let message = 'Play';

          if (game.pixellot_only) {
            return message;
          }

          // Start by checking the multiple audio setting (the override) to see what the message should be
          // After these checks depending on the games multiple audio (usually the leagues audio setting) display the correct message
          if (game.multiple_audio_setting === 1) {
            if (secondary) {
              message = 'Play w/ away audio';
            }
            else {
              message = 'Play w/ home audio';
            }
          } else if (game.multiple_audio_setting === 2) {
            if (secondary) {
              message = 'Play w/ French audio';
            } else {
              message = 'Play w/ English audio';
            }
          } else if (game.multiple_audio === 1) {
            if (secondary) {
              message = 'Play w/ away audio';
            } else {
              message = 'Play w/ home audio';
            }
          } else if (game.multiple_audio === 2) {
            if (secondary) {
              message = 'Play w/ French audio';
            } else {
              message = 'Play w/ English audio';
            }
          }
          return message;
        }
        return false;
      };

      $scope.downloadIconClass = function (game) {
        let class_name = null;

        switch (game.bdownloadgameflag) {
          case 2:
            class_name = null;
            break;
          case 1:
            class_name = 'preparing';
            break;
          case 0:
            class_name = 'prepare';
            break;
          case -1:
            class_name = 'not-available';
            break;
          default:
            if (game.blivegameflag <= 2 && game.barchivegameflag > 0) {
              class_name = 'disabled';
            }
            else {
              class_name = 'ready';
            }
            break;
        }

        return class_name;
      };

      $scope.downloadMessage = function (game, download) {
        let message = download.name+": ";

        // Be sure to initalize the array for each game.
        if (!(game.igameid in $scope.retrievingDownloads)) {
          $scope.retrievingDownloads[game.igameid] = {};
        }

        if ($scope.retrievingDownloads[game.igameid][download.audio_stream]) {
          message += "Retrieving Download..."
        } else {
          switch (download.status) {
            case 3:
              message += 'Download Ready';
              break;
            case 2:
            case 1:
              message += 'Processing';
              break;
            case 0:
              message += 'Prepare Download';
              break;
            case -1:
              message += 'Not Available';
              break;
            default:
              if (game.blivegameflag <= 2 && game.barchivegameflag > 0) {
                message += 'No Download';
              } else {
                message += 'Download Ready';
              }
          }
        }

        return message;
      };

      $scope.downloadGame = function (game, download) {
        $scope.downloadLinks[game.igameid] = null;
        if (download != undefined) {
          $scope.retrievingDownloads[game.igameid][download.audio_stream] = true;

          return gameActions.downloadGame(game, download)
            .then(response => {
              $scope.downloadLinks[game.igameid] = response;
              $scope.retrievingDownloads[game.igameid][download.audio_stream] = false;
            })
            .catch(response => {
              $scope.downloadLinks[game.igameid] = null;
              $scope.retrievingDownloads[game.igameid][download.audio_stream] = false;
            });
        }
      };

      $scope.toggleFavorites = () => {
        $scope.favoritesOpen = !$scope.favoritesOpen;
        $scope.onShowFavorites();
      };
    }
  ]);


// WEBPACK FOOTER //
// ./app.v2/components/schedule/gameActions/gameActionsController.js